/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import $ from 'jquery';
//import { v4 as uuidv4 } from 'uuid';
import { Loader, Segment, Dimmer } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import TreeTable from '../TreeTable/TreeTable';
import api from '../../api';
import SettingContentsHeaderByGroups from './SettingContentsHeaderByGroups';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import EditLocalGroupModal from '../Modal/EditLocalGroupModal';
import WithRouter from '../Extensions/WithRouter';

class LDAPGroupSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 10,
      //currentPage: 1,
      selectedGroupId: '',
      groupList: [],
      sortColumn: '1',
      isSort: false,
      searchKeyword: '',
      treeLoaded: false,
      //tree: {},
      //treeCollapsed: false,
      isExpand: true,
      isOpenMEG: false,
      memberList: [],
      projectList: [],
      selectedEvent: '',
      //activeIndex: '',
      isLocalSetting: false,
      isPageLoading: false,
    };
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleTableTree = this.handleTableTree.bind(this);
    this.handleMEGClose = this.handleMEGClose.bind(this);
    this.handleEditLocalGroupCallback = this.handleEditLocalGroupCallback.bind(this);
  }

  componentDidMount() {
    if (this.ldapGroupSetting) {
      this.onUpdateLoading();
    }

    $('body').on('click', '.setting_ldap_groups_table .content_wrapper a.edit_button', (event) => {
      const id = $(event.currentTarget)
        .closest('td')
        .attr('data-id');
      this.openLDAPInfo(id);
    });

    $('body').on('click', '.setting_ldap_groups_table .content_wrapper .number', (event) => {
      const $container = $('.container');
      const parentEl = $(event.currentTarget).closest('tr');
      const myIndex = $(event.currentTarget)
        .closest('td')
        .index();
      const id = parentEl
        .children()
        .eq(4)
        .attr('data-id');

      if (myIndex === 1) {
        this.getSGroupMemberDetail(event, id);
      } else {
        this.getSGroupProjectDetail(event, id);
      }

      $container.on('click', (e2) => {
        if ($(e2.currentTarget).children('.tooltip').length > 0) {
          return false;
        }
        $('.tooltip').remove();
      });
    });

    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.setting_table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 0) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      groupList, memberList, selectedEvent, projectList, isPageLoading
    } = this.state;
    if (groupList !== prevState.groupList) {
      $('.setting_ldap_groups_table tr').each(function () {
        const id = $(this)
          .find('td')
          .eq(4)
          .html();
        const memberCount = $(this)
          .find('td')
          .eq(1)
          .html();
        const projectCount = $(this)
          .find('td')
          .eq(2)
          .html();

        if (memberCount > 0) {
          $(this)
            .find('td')
            .eq(1)
            .empty();
          $(this)
            .find('td')
            .eq(1)
            .append(
              `<div class="content_wrapper"><span class="number">${memberCount}</span></div>`
            );
        }

        if (projectCount > 0) {
          $(this)
            .find('td')
            .eq(2)
            .empty();
          $(this)
            .find('td')
            .eq(2)
            .append(
              `<div class="content_wrapper"><span class="number">${projectCount}</span></div>`
            );
        }

        $(this)
          .find('td')
          .eq(4)
          .empty();
        $(this)
          .find('td:eq(4)')
          .append('<div class="content_wrapper"><a class="edit_button">Edit</a></div>')
          .attr('data-id', id);
      });
    }
    if (memberList !== prevState.memberList) {
      const event = selectedEvent;
      $('.tooltip').remove();
      $(event.currentTarget).css('position', 'relative');
      $(event.currentTarget).append('<div class="tooltip"></div>');
      const $ul = $('<div>', { class: 'ui list' }).append(
        memberList.map((item) => {
          return $('<div>', { class: 'item', text: item });
        })
      );

      $(event.currentTarget)
        .children('.tooltip')
        .append($ul);
    }

    if (projectList !== prevState.projectList) {
      const event = selectedEvent;
      $('.tooltip').remove();
      $(event.currentTarget).css('position', 'relative');
      $(event.currentTarget).append('<div class="tooltip"></div>');
      $('.tooltip').css('white-space', 'nowrap');
      const $ul = $('<div>', { class: 'ui list' }).append(
        projectList.map((item) => {
          return $('<div>', { class: 'item', text: item });
        })
      );

      $(event.currentTarget)
        .children('.tooltip')
        .append($ul);
    }

    if (prevState.isLoading !== isPageLoading && isPageLoading) {
      this.getsLDAPList();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  handleMEGClose(value) {
    if (value) {
      this.setState(
        {
          searchKeyword: '',
          groupList: [],
          isOpenMEG: false,
          isLocalSetting: false,
        },
        () => {
          this.getsLDAPList();
        }
      );
    } else {
      this.setState({
        isOpenMEG: false,
        isLocalSetting: false,
      });
    }
  }

  handleSearch(value) {
    this.setState(
      {
        treeLoaded: false,
        searchKeyword: value,
        groupList: [],
      },
      () => {
        this.getsLDAPList();
      }
    );
  }

  handleTableTree() {
    const { isExpand } = this.state;
    this.setState(
      {
        isExpand: !isExpand,
      },
      () => {
        $('.gray_button.util_button').trigger('click');
      }
    );
  }

  handleEditLocalGroupCallback() {
    this.setState(
      {
        groupList: [],
        treeLoaded: false,
      },
      () => {
        this.getsLDAPList();
      }
    );
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortColumn) {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: false,
          treeLoaded: false,
          groupList: [],
        },
        () => {
          this.getsLDAPList();
        }
      );
    } else {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          treeLoaded: false,
          isSort: !isSort,
          groupList: [],
        },
        () => {
          this.getsLDAPList();
        }
      );
    }
  };

  getsLDAPList = (pageNo, limit) => {
    let text;
    const { isSort, sortColumn } = this.state;
    const page = pageNo || 1;
    const perPage = limit || this.state.pageSize;

    switch (true) {
    case sortColumn === '1':
      if (isSort) {
        text = 'group';
      } else {
        text = 'group_r';
      }
      break;
    case sortColumn === '2':
      if (isSort) {
        text = 'member_r';
      } else {
        text = 'member';
      }
      break;
    case sortColumn === '3':
      if (isSort) {
        text = 'project_r';
      } else {
        text = 'project';
      }
      break;
    case sortColumn === '4':
      if (isSort) {
        text = 'modified_r';
      } else {
        text = 'modified';
      }
      break;
    default:
      text = 'modified';
      break;
    }

    api
      .getsLDAPList(
        {
          search: this.state.searchKeyword,
          page,
          limit: perPage,
          order: text,
        }
      )
      .then((response) => {
        this.setState({
          treeLoaded: true,
          groupList: response.response,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getSGroupMemberDetail = (value, groupId) => {
    api
      .getSGroupMemberDetail(groupId)
      .then((response) => {
        const data = response.response;
        this.setState({
          memberList: data.member_list,
          selectedEvent: value,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getSGroupProjectDetail = (value, groupId) => {
    api
      .getSGroupProjectDetail(groupId)
      .then((response) => {
        const data = response.response;
        this.setState({
          projectList: data.project_list,
          selectedEvent: value,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  openLDAPInfo(value) {
    const groupId = value;
    this.setState({
      isOpenMEG: true,
      isLocalSetting: false,
      selectedGroupId: groupId,
    });
  }

  /*
  handleClose() {
    const status = {
      projectPopup: false,
      memberPopup: false,
    };
    this.setState({
      popupStatus: status,
      activeIndex: '',
    });
  }
*/

  clearSearch() {
    this.setState(
      {
        treeLoaded: false,
        searchKeyword: '',
        groupList: [],
      },
      () => {
        this.getsLDAPList();
      }
    );
  }

  render() {
    const { groupList, isSort, sortColumn } = this.state;
    const { location, state, t } = this.props;
    const pathname = location.pathname ? location.pathname : location;

    const controlWithButton = {
      tableClasses: 'setting_ldap_groups_table',
      buttonClasses: 'gray_button util_button',
      showButton: true,
    };

    const columns = [
      {
        dataField: 'name',
        heading: 'Group Name',
        fixedWidth: true,
        percentageWidth: 49,
      },
      {
        dataField: 'member_count',
        heading: 'Group Members',
        fixedWidth: true,
        percentageWidth: 13,
      },
      {
        dataField: 'project_count',
        heading: 'Applied Projects',
        fixedWidth: true,
        percentageWidth: 13,
      },
      {
        dataField: 'last_modified',
        heading: 'Last Modified',
        fixedWidth: true,
        percentageWidth: 13,
      },
      {
        dataField: 'id',
        heading: 'Edit Btn',
        fixedWidth: true,
        percentageWidth: 11,
      },
    ];

    return (
      <div
        className="setting_ldap_group"
        ref={(ref) => {
          this.ldapGroupSetting = ref;
        }}
      >
        <SettingContentsHeaderByGroups
          clearSearch={this.clearSearch}
          onChangeSearch={this.handleSearch}
          isExpand={this.state.isExpand}
          handleTableTree={this.handleTableTree}
          location={pathname}
          state={state}
          translate={t}
        />
        <div className="content">
          <div className="setting_ldap_groups_content">
            <div className="setting_table_header">
              <div className="setting_table_header_inner">
                <table className="setting_groups_table table_header">
                  <colgroup>
                    <col style={{ width: '49%' }} />
                    <col style={{ width: '13%' }} />
                    <col style={{ width: '13%' }} />
                    <col style={{ width: '13%' }} />
                    <col style={{ width: '11%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        <a className="sorting_button" data-id="1" onClick={this.onChangeSorting}>
                          {t('system.list.group_name')}
                          {isSort && sortColumn === '1' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '1' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="2" onClick={this.onChangeSorting}>
                          {t('system.list.group_member')}
                          {isSort && sortColumn === '2' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '2' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="3" onClick={this.onChangeSorting}>
                          {t('settings.list.applied_projects')}
                          {isSort && sortColumn === '3' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '3' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="4" onClick={this.onChangeSorting}>
                          {t('system.list.last_modified')}
                          {isSort && sortColumn === '4' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '4' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            {this.state.treeLoaded ? (
              <div>
                <TreeTable tableData={groupList} columns={columns} control={controlWithButton} />
              </div>
            ) : (
              <div>
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="large">{t('list.title.loading')}</Loader>
                  </Dimmer>
                </Segment>
              </div>
            )}
          </div>
        </div>
        <EditLocalGroupModal
          isOpenMEG={this.state.isOpenMEG}
          isLocalSetting={this.state.isLocalSetting}
          groupId={this.state.selectedGroupId}
          closeModal={this.handleMEGClose}
          completeCallback={this.handleEditLocalGroupCallback}
          location={pathname}
          translate={t}
        />
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LDAPGroupSetting))));
